<template>
  <div class="d-flex justify-content-between align-items-center flex-wrap">
    <h2>{{ $t('campaignhometitle') }}</h2>
    <div>
      <b-button
        v-if="!isFree && groupRol != 'espejo'"
        variant="primary"
        class="mb-1 mb-sm-0 mr-1"
        @click="goToCampaigns"
      >
        {{ $t('campaigns.goToCampaigns') }}
      </b-button>
      <b-button 
        class="button-max-views mr-1 mb-1 mb-sm-0" 
        v-if="isFree" 
        @click="$emit('open-modal-create')"
      >
        {{ $t('campaigns.campaignsAvaible') }}: {{ campaignAvaible >= 0 ? campaignAvaible : '0' }}
      </b-button>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        @click="$emit('open-modal-create')"
        variant="blue-button"
        class="mb-1 mb-sm-0 blue-button"
        ref="toggleSide"
      >
        {{ $t('newcampaignbutton')}}
      </b-button>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'CampaignHeader',
  components: {
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    isFree: {
      type: Boolean,
      default: false
    },
    groupRol: {
      type: String,
      default: 'brand'
    },
    campaignAvaible: {
      type: Number,
      default: 0
    }
  },
  methods: {
    goToCampaigns() {
      this.$router.push({ name: 'my_work_brands', params: { section: 'campaigns' } }).catch(() => {})
    },
    triggerSidebarToggle() {
      this.$refs.toggleSide?.click()
    }
  }
}
</script>
